import React, { useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import ClipLoader from "react-spinners/ClipLoader";
import {
  useAddBadgeMutation,
  useUpdateBadgeMutation,
} from "../../Data/services/badgesApi";
import { useUploadAttachmentMutation } from "../../Data/services/uploadAttachmentApi";
import { typeList } from "../../Helper";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import { Button, Input } from "../CustomComponents";
import SelectFieldComponent from "../CustomComponents/SelectFieldComponent";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";

const EditBadgeModal = ({ handleEditModalClose, editData, refetch }) => {
  const [rowId, setRowId] = useState("");
  const [name, setName] = useState();
  const [criteriaValue, setCriteriaValue] = useState();
  const [description, setDescription] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [imageFile, setImageFile] = useState("");
  const [imagePreview, setImagePreview] = useState("");
  const [sending, setSending] = useState(false);

  const [selectedType, setSelectedType] = useState(10);
  // const typeList = [
  //   { label: "POLL VOTE", value: 10 },
  //   { label: "POLL WIN", value: 20 },
  // ];

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (editData) {
      // console.log(editData);
      setRowId(editData.id);
      setName(editData.name || { en: "", ar: "" });
      setImageUrl(editData.icon_url);
      setImagePreview(editData.icon_url || "");
      setDescription(editData.description || "");
      setCriteriaValue(editData.criteria_value || "");
      setSelectedType(parseInt(editData.criteria_type) || 10);
    }
  }, [editData, mounted]);

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const [uploadAttachment, { isLoading: isUploading }] =
    useUploadAttachmentMutation();

  const handleImagePreview = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleImageUpload = async (e) => {
    const formData = new FormData();
    formData.append("file", imageFile);
    formData.append("path", "badge");

    // Loop through formData
    for (let [key, value] of formData.entries()) {
      console.log(key, value);
    }

    try {
      const response = await uploadAttachment({ formData }).unwrap();
      console.log(response);
      return response.data[0];
    } catch (error) {
      Toast("Failed to upload image", "error");
    }
  };

  const handleDescription = (e) => {
    // console.log(e.target.value);
    setDescription(e.target.value);
  };

  const handleTypeChange = (value) => {
    console.log(value);
    setSelectedType(value);
  };

  const [addCategory, { isLoading: adding }] = useAddBadgeMutation();
  const [updateCategory, { isLoading: updating }] = useUpdateBadgeMutation();

  const handleSubmit = async () => {
    console.log(rowId);
    // console.log(name);
    // console.log(imageUrl);

    setSending(true);
    try {
      let imageName;
      if (imageFile) {
        imageName = await handleImageUpload();
      }

      if (!name || !selectedType || !criteriaValue) {
        Toast("Please fill all the fields", "error");
        setSending(false);
        return;
      }

      const data = {
        name: name,
        description: description,
        criteria_type: parseInt(selectedType) || 10, // default to 10 if not selected
        criteria_value: criteriaValue,
        icon_url: (await imageName) || imageUrl || "", // already uploaded image URL
      };

      console.log(data);

      let response;
      if (editData) {
        response = await updateCategory({ data, id: rowId }).unwrap();
      } else {
        response = await addCategory(data).unwrap();
      }

      console.log(response);

      if (response.code === 200) {
        refetch();
        setSending(false);
        SuccessToast(response?.message);
        handleEditModalClose();
      }
    } catch (error) {
      console.log(error);
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
      handleEditModalClose();
      setSending(false);
    }
  };

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleEditModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 ">
              {editData ? "Edit Badge" : "Add Badge"}
            </p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleEditModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="w-100">
            <Row>
              <Col md={12}>
                <Input
                  classes="mt-2 mb-3"
                  type="text"
                  placeholder="Enter name"
                  value={name}
                  onChange={handleNameChange}
                />
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <SelectFieldComponent
                  firstOption={selectedType ? selectedType : "Select Type"}
                  optionsList={typeList}
                  onSelectChange={handleTypeChange}
                />
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <Input
                  classes="mt-2 mb-3"
                  type="number"
                  placeholder="Enter criteria value"
                  value={criteriaValue}
                  onChange={(e) => {
                    setCriteriaValue(e.target.value);
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col md={9}>
                <Input
                  classes="mt-2 mb-3"
                  type="file"
                  placeholder="Image"
                  onChange={(e) => {
                    // handleImageUpload(e);
                    handleImagePreview(e);
                  }}
                />
              </Col>

              <Col md={3}>
                {isUploading ? (
                  <Spinner />
                ) : (
                  <img
                    src={
                      imagePreview || imageUrl || "https://placehold.co/100x100"
                    }
                    alt="category_image"
                    width={100}
                    height={100}
                    className="rounded"
                  />
                )}
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <Input
                  classes="mt-2 mb-3"
                  type="textarea"
                  rows={5}
                  as="textarea"
                  name="answer"
                  placeholder="Enter description"
                  value={description}
                  onChange={handleDescription}
                />
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <Button
                  classes={`mt-3 mb-2 ${
                    sending ||
                    !name ||
                    !selectedType ||
                    !criteriaValue ||
                    !imagePreview
                      ? "bg-dark-subtle"
                      : "shadow"
                  } `}
                  text={
                    sending ? (
                      <ClipLoader color="#0f0f0f" size="22px" />
                    ) : editData ? (
                      "Update"
                    ) : (
                      "Save"
                    )
                  }
                  disabled={
                    sending ||
                    !name ||
                    !selectedType ||
                    !criteriaValue ||
                    !imagePreview
                  }
                  onClick={handleSubmit}
                ></Button>
              </Col>
            </Row>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default EditBadgeModal;
